import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import * as Icons from "../Icons";
import "./EnvironmentInfoSection.css";

const EnvironmentInfoSection = () => {
  const data = {
    restaurants: [
      { name: "Ristorante Pizzeria la Terrazza", dist: "200 m" },
      { name: "Bar Giornali", dist: "450 m" },
      { name: "Pescheria Domus De Mare", dist: "5 km" },
    ],
    beaches: [
      { name: "Spiaggia di Porto Ottiolu", dist: "2,1 km" },
      { name: "Spiaggia di Budoni", dist: "5,8 km" },
      { name: "Spiaggia Isuledda", dist: "7,2 km" },
      { name: "Spiaggia La Cinta", dist: "9,3 km" },
      {
        name: "Cala Brandinchi (Registrierung notwendig; https://santeodorospiagge.it",
        dist: "19 km",
      },
    ],
    activities: [
      { name: "Wandern · Area naturalistica del Monte Nieddu", dist: "9,2 km" },
      {
        name: "Wandern · Seconda cascata e Piscina Naturale rio Pitrisconi",
        dist: "12 km",
      },
      {
        name: "Pferde- und Ponyranch · Maneggio Budoni Sardigna",
        dist: "950 m",
      },
      { name: "Go-Kart-Bahn · Pista Jolly Park", dist: "1,3 km" },
      { name: "Fahrradverleih · Budoni E-Bikes & Scooters", dist: "3,1 km" },
    ],
    airports: [{ name: "Flughafen Olbia Costa Smeralda", dist: "33 km" }],
  };

  return (
    <section className="py-5 bg-white">
      <Container>
        {/* Header Bereich */}
        <div className="mb-5">
          <h2 className="fw-bold mb-1">Umgebung</h2>
        </div>

        {/* lg={3} sorgt für 4 Spalten auf großen Bildschirmen */}
        <Row className="g-4">
          {/* Spalte 1: Restaurants */}
          <Col lg={6} md={6}>
            <div className="d-flex align-items-center mb-4">
              <Icons.Cutlery className="environment" />
              <h3
                className="h6 fw-bold mb-0 environment"
                style={{ marginLeft: "12px" }}
              >
                Restaurants & Cafés
              </h3>
            </div>
            {data.restaurants.map((item, i) => (
              <div
                key={i}
                className="d-flex justify-content-between py-2 border-bottom align-items-center env-info"
              >
                <span className="text-dark small pe-2 item-name">
                  {item.name}
                </span>
                <span className="dist text-dark small whitespace-nowrap text-end item-dist">
                  {item.dist}
                </span>
              </div>
            ))}
          </Col>

          {/* Spalte 2: Strände */}
          <Col lg={6} md={6}>
            <div className="d-flex align-items-center mb-4">
              <Icons.Umbrella className="environment" />
              <h3
                className="h6 fw-bold mb-0 environment"
                style={{ marginLeft: "12px" }}
              >
                Schöne Strände in der Umgebung
              </h3>
            </div>
            {data.beaches.map((item, i) => (
              <div
                key={i}
                className="d-flex justify-content-between py-2 border-bottom align-items-center env-info"
              >
                <span className="text-dark small pe-2 item-name">
                  {item.name}
                </span>
                <span className="dist text-dark small whitespace-nowrap text-end item-dist">
                  {item.dist}
                </span>
              </div>
            ))}
          </Col>

          {/* Spalte 3: NEU - Aktivitäten */}
          <Col lg={6} md={6}>
            <div className="d-flex align-items-center mb-4">
              <Icons.Activity className="environment" />
              <h3
                className="h6 fw-bold mb-0 environment"
                style={{ marginLeft: "12px" }}
              >
                Aktivitäten
              </h3>
            </div>
            {data.activities.map((item, i) => (
              <div
                key={i}
                className="d-flex justify-content-between py-2 border-bottom align-items-center env-info"
              >
                <span className="text-dark small pe-2 item-name">
                  {item.name}
                </span>
                <span className="dist text-dark small whitespace-nowrap text-end item-dist">
                  {item.dist}
                </span>
              </div>
            ))}
          </Col>

          {/* Spalte 4: Flughäfen */}
          <Col lg={6} md={6}>
            <div className="d-flex align-items-center mb-4">
              <Icons.Plane className="environment" />
              <h3
                className="h6 fw-bold mb-0 environment"
                style={{ marginLeft: "12px" }}
              >
                Nächstgelegene Flughäfen
              </h3>
            </div>
            {data.airports.map((item, i) => (
              <div
                key={i}
                className="d-flex justify-content-between py-2 border-bottom align-items-center env-info"
              >
                <span className="text-dark small pe-2 item-name">
                  {item.name}
                </span>
                <span className="dist text-dark small whitespace-nowrap text-end item-dist">
                  {item.dist}
                </span>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EnvironmentInfoSection;
